import React__default from 'react';
import PropTypes from 'prop-types';
import { brands } from '../../tools/constants.js';

var propTypes = {
  description: PropTypes.string.isRequired,
  brand: PropTypes.oneOf(brands),
  discountPrice: PropTypes.string,
  discountText: PropTypes.string,
  originalPrice: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.oneOf(['', 'original', 'discount', 'member', 'refund'])
};
function ProductPrice(_ref) {
  var brand = _ref.brand,
    description = _ref.description,
    discountPrice = _ref.discountPrice,
    discountText = _ref.discountText,
    originalPrice = _ref.originalPrice,
    size = _ref.size,
    variant = _ref.variant;
  return /*#__PURE__*/React__default.createElement("span", {
    className: "product-price",
    "data-brand": brand || null,
    "data-testid": "product-price",
    "data-variant": variant
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "screen-reader-text"
  }, description), /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "product-price-text-wrapper",
    "data-testid": "product-price-text-wrapper"
  }, discountPrice ? [originalPrice, discountPrice].map(function (aPrice, anIndex) {
    return /*#__PURE__*/React__default.createElement("span", {
      className: "product-price-text product-price-font-size",
      "data-size": size || null,
      "data-variant": anIndex === 0 && ['discount', 'member'].includes(variant) ? 'original' : variant,
      key: "price-".concat(aPrice)
    }, aPrice);
  }) : /*#__PURE__*/React__default.createElement("span", {
    className: "product-price-text product-price-font-size",
    "data-size": size,
    "data-variant": ['refund', 'member'].includes(variant) ? variant : '',
    key: "price-".concat(originalPrice)
  }, originalPrice)), discountText && /*#__PURE__*/React__default.createElement("span", {
    className: "clearance-badge"
  }, discountText));
}
ProductPrice.propTypes = propTypes;

export { ProductPrice as default };
//# sourceMappingURL=ProductPrice.js.map
